export default __webpack_public_path__ + "static/media/careersimg.0e9b34c7.jpg";